import React, { useReducer, useEffect, useContext} from "react";
import tareaContext from "./tareaContex";
import { getAllTarea, addTarea, updateTarea, deleteTarea } from "../../api/tarea";
import tareaReducer from "./tareaReducer";
import authContext from "../authentication/authContex";

//Types
import { 
    ACTUALIZAR_LIST_TAREA,
  } from "./tareaActions";
import { SocketContext } from "../socket/socket";

const TareaState = props =>{

    const initialState = {
        tareaIDLista: []
     };

    const [state, dispatch] = useReducer(tareaReducer, initialState);
    const server = useContext(SocketContext);
    const auContext = useContext(authContext);
    const {usuario, verificarTenant} = auContext;

    const actualizarTareaLista = async () => {
        try{
            const resp = await getAllTarea();
            const tarea = resp.data.data;
            dispatch({
                type: ACTUALIZAR_LIST_TAREA,
                payload: tarea
            });
            return tarea;
        }catch(err){
            console.log(err)
        }
    };

    const agregarTarea = async (dato) => {
        try{
            // Luego, puedes enviar estos datos al backend usando una función llamada addTarea
            const resp = await addTarea(dato);
            const tarea = resp.data.data;
            return tarea;
        }catch(err){
            console.log(err);
            return null;
        }
    };

    const modificarTarea = async (dato) => {
        try{
            const resp = await updateTarea(dato);
            const activo = resp.data.data;
            return activo;
        }catch(err){
            console.log(err)
            return null;
        }
    }

    const eliminarTarea = async (id, tDocID) => {
        try{
            const resp = await deleteTarea(id, tDocID);
            return resp;
        }catch(err){
            console.log(err)
        }
    }

    useEffect(() => {
        if(usuario != null) actualizarTareaLista();
    },[usuario])

    useEffect(()=>{
            if(server){
                server.on('tasksEdited', ({tenantId}) =>{
                    console.log("Recibo el evento del Real Time Server tasksEdited");
                    const verification = verificarTenant(tenantId)
                    if(verification){
                        actualizarTareaLista();
                    }
                })
                return () => {
                    server.off('tasksEdited');
                }
            }
        },[server])

    return(
        <tareaContext.Provider
            value={{
                tareaIDLista: state.tareaIDLista,
                actualizarTareaLista,
                agregarTarea,
                modificarTarea,
                eliminarTarea
            }}
        >
            {props.children}
        </tareaContext.Provider>
    )

}

export default TareaState;